import { useNavigate, useLocation } from "react-router-dom";
import { Calendar, DollarSign, ListChecks, Settings, ShieldCheck } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

// Persistent bottom navigation across every /driver/* page so the operator
// (or any driver, when we scale beyond beta) never has to memorize URLs.
// Admin tab is hidden unless the user has the admin role.
const TABS = [
  { to: "/driver/bookings", icon: ListChecks, label: "Rides",    testid: "nav-bookings" },
  { to: "/driver/schedule", icon: Calendar,   label: "Schedule", testid: "nav-schedule" },
  { to: "/driver/earnings", icon: DollarSign, label: "Earnings", testid: "nav-earnings" },
  { to: "/driver/settings", icon: Settings,   label: "Settings", testid: "nav-settings" },
];

export default function DriverBottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAdmin } = useAuth();

  const tabs = isAdmin
    ? [...TABS, { to: "/driver/admin", icon: ShieldCheck, label: "Admin", testid: "nav-admin" }]
    : TABS;

  return (
    <>
      {/* Spacer so page content isn't hidden behind the fixed bar */}
      <div className="h-20" aria-hidden />
      <nav
        className="fixed bottom-0 inset-x-0 z-40 bg-[#0a0a0a]/95 backdrop-blur border-t border-white/10 pb-[env(safe-area-inset-bottom)]"
        data-testid="driver-bottom-nav"
      >
        <div className="max-w-3xl mx-auto px-2 py-1.5 flex items-stretch justify-around">
          {tabs.map(({ to, icon: Icon, label, testid }) => {
            const active = location.pathname === to || location.pathname.startsWith(to + "/");
            return (
              <button
                key={to}
                onClick={() => navigate(to)}
                data-testid={testid}
                className={`flex flex-col items-center justify-center gap-0.5 flex-1 py-1.5 rounded-lg transition-colors ${
                  active ? "text-[#4D88FF]" : "text-white/55 hover:text-white"
                }`}
              >
                <Icon className={`w-5 h-5 ${active ? "drop-shadow-[0_0_4px_rgba(77,136,255,0.6)]" : ""}`} />
                <span className={`text-[10px] font-semibold tracking-wide uppercase ${active ? "" : "opacity-80"}`}>
                  {label}
                </span>
              </button>
            );
          })}
        </div>
      </nav>
    </>
  );
}
